import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./clinic-view-page"), {
  testId: "rd-clinic-view-loading",
  // «Мой профиль» → «Информация о клинике».
  shell: {
    breadcrumbRoot: { id: "redesign.profile.title", defaultMessage: "My profile", to: "/pages/my_account" },
    breadcrumbLeaf: { id: "redesign.clinic_view.title", defaultMessage: "Clinic information" },
  },
});
